import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-text-section">
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-message">
            {t('error.not_found_title', 'Lo sentimos, no encontramos la página que buscas.')}
          </h2>
          <div className="not-found-submessage">
            <p>{t('error.not_found_desc', 'Para continuar, utiliza el botón de Inicio o envíanos un correo a:')}</p>
            <a href="mailto:info@consultoriaglobal.com.ar" className="not-found-email">info@consultoriaglobal.com.ar</a>
          </div>
          <button 
            className="not-found-button"
            onClick={() => navigate('/')}
          >
            {t('error.back_home', 'Volver al Inicio')}
          </button>
        </div>
        <div className="not-found-image-section">
          <img src="/Lupa.svg" alt="Lupa" className="not-found-magnifier-svg" />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
